import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, inject } from '@angular/core';
import { SeoComponent } from '@shared/components';
import { WindowService } from '@shared/window/window.service';
import { RoutingTabTitleService } from '@shared/service/routing-tab-title/routing-tab-title.service';
import { tap } from 'rxjs/operators';
import { ShowroomComponent } from '../components/showroom/showroom.component';
import { MeetFormComponent } from '../components/meet-form/meet-form.component';
import { OurProductsComponent } from '../components/our-products/our-products.component';
import { OurPartnersComponent } from '../components/our-partners/our-partners.component';
import { OurPartnersLogosComponent } from '../components/our-partners-logos/our-partners-logos.component';

@Component({
    selector: 'app-our-showroom',
    templateUrl: './our-showroom.component.html',
    styleUrls: ['./our-showroom.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ShowroomComponent, MeetFormComponent, OurProductsComponent, OurPartnersComponent, OurPartnersLogosComponent],
})
export class OurShowroomComponent extends SeoComponent implements OnInit, OnDestroy {
    private routingTabTitleService = inject(RoutingTabTitleService);
    private windowService = inject(WindowService);

    override ngOnInit(): void {
        super.ngOnInit();
        this.windowService.scrollTop();

        this.subscriptions$.add(
            this.routingTabTitleService.currentPageTitle$
                .pipe(
                    tap((title) => {
                        this.seoTitle$.next(title);
                        this.seoDescription$.next(this.routingTabTitleService.translateTitle('SEO.OUR_SHOWROOM.description'));
                    }),
                )
                .subscribe(),
        );
    }
}
